import { useContext, ContextType } from 'react';

import { WelcomeViewWrapperContext } from './welcome-view-wrapper-context';

export function useWelcomeViewWrapperContext(): NonNullable<
  ContextType<typeof WelcomeViewWrapperContext>
> {
  const contextValues = useContext(WelcomeViewWrapperContext);
  if (!contextValues) {
    throw new Error('used outside the context provider useWelcomeViewWrapperContext');
  }

  return contextValues;
}
